import type {PhoneNumberEditationRequest} from 'src/typings';
import type {DefaultOptions} from 'shared/value-editors/types';
import type {
    TelephoneNumberValueEditorLocalizations,
    TelephoneNumberValueEditorOptions
} from 'shared/value-editors/internal/editors/telephone-number/types';

export const TELEPHONE_NUMBER_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<TelephoneNumberValueEditorOptions> = {
    forceSmsCapableOnly: false,
    defaultPrefix: '+420',
    customEmptyAsNullCheck: ({value}: { value: PhoneNumberEditationRequest }) => (value?.value ?? '').length === 0
};

export const TELEPHONE_NUMBER_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<TelephoneNumberValueEditorLocalizations>({
    description: '',
    pattern: 'Wrong telephone number format',
    forSmsMessages: 'Supports text messages:',
    forSmsOnly: 'Only for text messages',
});